import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFrameworksListAPI } from "../../../apiConfig/apiCall";

export const getFrameworksList = createAsyncThunk('getFrameworksList', async () => {
    const response = await getFrameworksListAPI();
    return response.data;
});